import { render, staticRenderFns } from "./DecreaseView.vue?vue&type=template&id=752811b2"
import script from "./DecreaseView.vue?vue&type=script&lang=js"
export * from "./DecreaseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports